export default "__VITE_ASSET__CMhwPc$f__"